'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMdl = require('react-mdl');

require('./Stepper.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Stepper = function Stepper(props) {
  var activeStep = props.activeStep,
      horizontal = props.horizontal,
      hideLastTitle = props.hideLastTitle,
      onStepTitleClick = props.onStepTitleClick;

  var children = _react.Children.toArray(props.children);
  var last = hideLastTitle && children.pop();
  var stepperClass = (0, _classnames2.default)('mdl-stepper', {
    'mdl-stepper--horizontal': horizontal,
    'mdl-stepper--vertical': !horizontal
  });
  return _react2.default.createElement(
    'div',
    { className: stepperClass },
    _react2.default.createElement(
      'ul',
      { className: 'mdl-stepper__steps' },
      children.map(function (child, index) {
        var stepClass = (0, _classnames2.default)('mdl-stepper__step', {
          'mdl-stepper__step--active': index === activeStep,
          'mdl-stepper__step--completed': index < activeStep
        });
        var wrapStyle = { cursor: onStepTitleClick ? 'pointer' : 'default' };
        return _react2.default.createElement(
          'li',
          { className: stepClass, key: '' + child.props.title + index },
          _react2.default.createElement(
            'div',
            { className: 'mdl-stepper__title', onClick: function onClick() {
                return onStepTitleClick(index);
              } },
            _react2.default.createElement(
              'span',
              { className: 'mdl-stepper__title-wrap', style: wrapStyle },
              _react2.default.createElement(
                'span',
                { className: 'mdl-stepper__title-text' },
                child.props.title
              ),
              _react2.default.createElement(
                'span',
                { className: 'mdl-stepper__title-icon' },
                activeStep > index ? _react2.default.createElement(_reactMdl.Icon, { name: 'check' }) : index + 1
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'mdl-stepper__content' },
            child.props.children
          )
        );
      })
    ),
    hideLastTitle && activeStep === children.length && _react2.default.createElement(
      'div',
      { className: 'mdl-stepper__last' },
      last.props.children
    )
  );
};

Stepper.propTypes = {
  activeStep: _react.PropTypes.number.isRequired,
  children: _react.PropTypes.any.isRequired,
  hideLastTitle: _react.PropTypes.bool,
  horizontal: _react.PropTypes.bool,
  onStepTitleClick: _react.PropTypes.func
};

exports.default = Stepper;


//////////////////
// WEBPACK FOOTER
// ./~/react-mdl-extra/lib/Stepper/Stepper.js
// module id = 824
// module chunks = 0